<template>
  <div class="full-height">
    <img :src="src" v-bind="$attrs" />

    <q-inner-loading :visible="!loaded" dark>
      <q-spinner />
    </q-inner-loading>
  </div>
</template>

<script>
  import { DocumentsClient } from 'src/api/Documents'

  const PLACEHOLDER_IMG = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTk1IiBoZWlnaHQ9Ijg0MiIgdmlld0JveD0iMCAwIDU5NSA4NDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI1OTUiIGhlaWdodD0iODQyIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K'

  export default {
    props: {
      model: {
        type: Object,
        requried: true
      }
    },
    data () {
      return {
        src: PLACEHOLDER_IMG,
        loaded: false
      }
    },
    computed: {
      documentId () {
        return this.model.document.data.id
      }
    },
    methods: {
      fetchPreview () {
        return new DocumentsClient()
          .preview(this.documentId)
          .then((response) => {
            // If preview not generated response status code is 204
            if (response.status === 200) {
              const arrayBuffer = new Uint8Array(response.data)
              const blob = new Blob([arrayBuffer], { type: 'image/png' })

              this.src = URL.createObjectURL(blob)
              this.loaded = true
            } else if (response.status === 204) {
              this.src = PLACEHOLDER_IMG
            }

            return response
          })
      },
      loadUntilLoaded () {
        const interval = window.setInterval(() => {
          this.fetchPreview()
            .then((response) => {
              if (response.status === 200) {
                window.clearInterval(interval)
              }
            })
        }, 1000)
      }
    },
    created () {
      this.fetchPreview()
        .then((response) => {
          if (response.status === 204) {
            this.loadUntilLoaded()
          }
        })
    }
  }
</script>
